import { Gender, EducationLevel } from '../enums';

export class DemographicResponses {
    public title?: string;
    public gender?: Gender;
    public birthDate?: Date;
    public city?: string;
    public state?: string;
    public country?: string;
    public educationLevel?: EducationLevel;
}


// WEBPACK FOOTER //
// ./src/models/DemographicResponses.tsx